import { Box, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import gaiaLogo from '../../../assets/corporate-logos/gaia/gaia-logo-white.png'
import { usePdfExportMode } from '../../../hooks/use-pdf-export-mode'
import { GAIA_PDF_PAGE_HEIGHT_PX } from './gaia-report-web-page-pdf-styles'
import { useReportContentOverride } from '../shared-services/gaia-report-content'

/**
 * Closing / back page. Renders an optional user heading + message above the
 * logo. The "Report generated by Gaia Carbon Accounting" attribution stays
 * fixed beneath for direct (non-partner) customers.
 */
export const GaiaReportWebPageClosing: FunctionComponent<{
  darkColor: string
  partnerLogoFilepath?: string | null
  isDirectCustomer: boolean
}> = ({ darkColor, partnerLogoFilepath, isDirectCustomer }) => {
  const pdfExport = usePdfExportMode()
  const heading = useReportContentOverride('closing.heading')
  const message = useReportContentOverride('closing.message')

  return (
    <Stack
      sx={{
        backgroundColor: darkColor,
        minHeight: pdfExport ? `${GAIA_PDF_PAGE_HEIGHT_PX}px` : '100vh',
        boxSizing: 'border-box',
        borderRadius: pdfExport ? 0 : '40px 40px 0 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 2,
        px: 4,
        ...(pdfExport ? {} : {
          mt: -5,
          position: 'relative',
          zIndex: 2,
        }),
      }}>
      {heading && (
        <Typography variant={pdfExport ? 'h4' : 'h3'} sx={{ color: 'white', fontWeight: 700, maxWidth: '80%' }}>{heading}</Typography>
      )}
      {message && (
        <Typography sx={{ color: 'white', fontSize: pdfExport ? '0.95rem' : '1.1rem', maxWidth: '70%' }}>{message}</Typography>
      )}
      <img src={partnerLogoFilepath || gaiaLogo} alt='gaia logo' height={75} />
      {isDirectCustomer && (
        <Typography sx={{ color: 'white', fontSize: pdfExport ? '0.95rem' : '1rem' }}>
          Report generated by Gaia Carbon Accounting.{' '}
          {pdfExport ? (
            'gaiacompany.io'
          ) : (
            <Box
              component='a'
              href='https://gaiacompany.io'
              target='_blank'
              rel='noreferrer'
              sx={{ color: 'white', textDecoration: 'underline' }}
            >
              gaiacompany.io
            </Box>
          )}
        </Typography>
      )}
    </Stack>
  )
}
